import React from "react";
import "./SolutionsSection.css";

import { motion } from "framer-motion";

const SolutionsSection = ({
  title, 
  subtitle, 
}) => {
  return (
    <motion.section
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
      >
      <section className="hero-section-solutions">
        <div className="hero-container-solutions">
          <h1>{title}</h1>
          <p>{subtitle}</p>
          
          <div className="button-group">
           <a 
            href="/book" 
            className="primary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Book a Demo
          </a>
          <a 
            href="/contact" 
            className="secondary-btn" 
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Contact
          </a>
        </div>
        </div>
      </section>
    </motion.section>
  );
};
export default SolutionsSection;